export const VALIDATION_VALID = 'valid'
export const VALIDATION_WARN = 'warning'
export const VALIDATION_ERROR = 'error'
export const VALIDATION_MISSING = 'missing'
export const VALIDATION_FORMAT = 'format'

export type Invalid = boolean
export interface Validation {
  invalid: Invalid,
  message?: string,
  status?: string,
}

export const validValidation: Validation = {
  invalid: false,
  status: VALIDATION_VALID,
}

export const missingValidation: Validation = {
  invalid: true,
  status: VALIDATION_MISSING,
}

export type DropdownKey = number | string

export interface DropdownOption {
  description: string,
  key: DropdownKey,
}

export interface DropdownOnChangeArg {
  name: string,
  value: string
}



// WEBPACK FOOTER //
// ./src/components/rasa-input/types.ts